<template>
  <div v-if="upload" class="upload-box" :class="{ 'minimized' : minimized }" @dblclick="minimized = !minimized">
    <div class="upload-content">
      <input @change="selectFile" ref="file" type="file" accept="video/mp4" style="display: none" />
      <img v-if="showData" :src="showData.image" class="show-image" />
      <div v-if="showData" class="show-name">{{ showData.name }}</div>
      <button v-if="!file && !notSupported" @click="$refs.file.click()" type="button" class="btn-upload">{{ uploadData ? 'Selecione o arquivo para continuar' : 'Selecionar Vídeo' }}</button>
      <div v-if="uploadData" class="upload-file">{{ uploadData.filename }}</div>
      <div v-if="uploadData" class="upload-status">
        <button v-if="file" @click="playOrPause" class="upload-start-stop" type="button"><i class="fas" :class="uploading ? 'fa-pause' : 'fa-play'"></i></button>
        <div style="flex-grow: 1">
          <div class="upload-progress">
            <div class="progress-bar" :style="`width: ${getPercent(uploaded, uploadData.size)}%`">{{ getPercent(uploaded, uploadData.size) }}%</div>
          </div>
          <div class="upload-size">{{ convertToMB(uploaded) }} / {{ convertToMB(uploadData.size) }} MB</div>
        </div>
      </div>
      <div v-if="finished" class="upload-finished">
        <i class="fas fa-check"></i>
        <span>Upload do vídeo realizado com sucesso</span>
      </div>
      <div class="upload-error">{{ error }}</div>
      <button @click="cancel" class="btn-cancel">{{ uploadData ? 'Cancelar' : 'Fechar' }}</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { start, cancel, uploading } from '../api/showUpload'
import { get } from '../api/show'

export default {
  name: 'showVideo',

  data () {
    return {
      minimized: false,
      showData: null,
      file: null,
      reader: null,
      uploaded: 0,
      uploading: false,
      notSupported: false,
      uploadData: null,
      finished: false,
      error: null
    }
  },
  computed: {
    ...mapState(['upload'])
  },
  watch: {
    async upload (value) {
      if (!value) return false
      try {
        const show = await get(value)
        show.image = `${process.env.VUE_APP_IMG}/${show.business}/${show.id}/${show.images[0]}`
        this.showData = show
      } catch (error) {
        console.error(error)
      }
    }
  },
  async created () {
    if (!File && !File.slice && !FileReader) {
      this.notSupported = true
      this.error = 'Navegador não suporta este formato de upload'
    }
    // Check if has not finished upload
    try {
      const upload = await uploading(this.$analytics.session())
      if (upload) {
        const show = await get(upload.show)
        show.image = `${process.env.VUE_APP_IMG}/${show.business}/${show.id}/${show.images[0]}`
        this.showData = show
        this.uploadData = upload
        this.uploaded = upload.uploaded
        this.$store.commit('upload', upload.show)
      }
    } catch (error) {
      logger.error(error, this)
    }
    // File reader
    this.reader = new FileReader()
    this.reader.onload = (event) => {
      this.$socket.emit('show-upload', {
        id: this.uploadData.id,
        filename: this.file.name,
        size: this.file.size,
        lastModified: this.file.lastModified,
        chunk: event.target.result
      })
    }
    // On more data
    this.$socket.on('show-upload-more', (data) => {
      this.uploaded = data.uploaded
      if (this.uploading) this.sendChunck()
    })
    // On finished
    this.$socket.on('show-upload-finished', () => {
      this.uploadData = null
      this.finished = true
      this.minimized = false
    })
    // On error
    this.$socket.on('show-upload-error', (data) => {
      if (data.code === 'different-file') {
        this.error = 'Arquivo selecionado diferente do original'
        this.uploading = false
        this.file = null
      } else {
        this.error = 'Ocorreu um problema ao salvar o arquivo. Tente novamente'
        this.uploading = false
      }
    })
    // On disconnect
    this.$socket.on('disconnect', () => {
      this.error = 'Ocorreu um problema ao se conectar ao servidor. Tente novamente'
      this.uploading = false
    })
  },
  methods: {
    async selectFile (event) {
      const file = event.target.files[0]
      try {
        this.file = file
        if (!this.uploadData) {
          this.uploadData = await start(
            this.$analytics.session(),
            this.upload,
            file.name,
            file.lastModified,
            file.size
          )
        }
        this.$refs.file.value = null
        this.uploading = true
        this.sendChunck()
        setTimeout(() => { this.minimized = true }, 2000)
      } catch (error) {
        const data = error.response ? error.response.data : {}
        if (data.error === 'duplicated') {
          this.error = 'Já foi realizado um upload com o mesmo nome. Altere o nome do arquivo.'
        } else {
          logger.error(error, this)
          this.error = 'Ocorreu um problema ao iniciar o upload. Tente novamente'
        }
        this.uploading = false
        this.minimized = false
      }
    },
    playOrPause () {
      if (this.uploading) {
        this.uploading = false
      } else {
        this.error = null
        this.uploading = true
        this.sendChunck()
      }
    },
    sendChunck () {
      // 5MB CHUNK
      const chunk = this.file.slice(this.uploaded, this.uploaded + Math.min(5242880, this.file.size - this.uploaded))
      this.reader.readAsBinaryString(chunk)
    },
    async cancel () {
      try {
        if (this.uploadData) {
          await cancel(this.uploadData.id)
        }
        this.file = null
        this.reader = null
        this.uploaded = 0
        this.uploading = false
        this.uploadData = null
        this.$store.commit('upload', null)
      } catch (error) {
        logger.error(error, this)
      }
    },
    getPercent (value, total) {
      return Math.round(Number(value) / Number(total) * 100)
    },
    convertToMB (value) {
      return Math.round(Number(value) * 0.00000095367432)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.upload-box {
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
  z-index: 98;
  width: 300px;
  height: 300px;
  margin: 5px;
  background-color: #fdfdfd;
  border: 1px solid #ddd;
  box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.3);
  border-radius: 10px;
  transition: all 0.5s;

  &.minimized {
    transform: translate(0, 0);
    bottom: 0;
    left: 2px;
    height: 50px;
    width: calc(#{$menu-width-open} - 15px);
    .show-image, .show-name, .upload-file, .btn-cancel, .upload-error {
      display: none;
    }
    .upload-content {
      padding: 10px 5px;
    }
  }
}

.upload-content {
  height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px;
}

.show-image {
  object-fit: cover;
  width: 150px;
  height: 80px;
  border-radius: 5px;
}

.show-name {
  text-align: center;
  margin: 10px 5px;
  color: #333;
}

.btn-upload {
  color: #fff;
  border: none;
  border: 1px solid $primary-color;
  border-radius: 5px;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  padding: 5px 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}

.upload-file {
  color: $primary-color;
}

.upload-status {
  display: flex;
  align-items: center;
  width: 100%;
}

.upload-start-stop {
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  color: $primary-color;
  border: 1px solid $primary-color;
  border-radius: 5px;
  font-size: 15px;
  margin-right: 10px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}

.upload-progress {
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 15px;
  width: 100%;
  .progress-bar {
    background: linear-gradient(to bottom right, #0071b3, #0098b3);
    border-radius: 4px;
    text-align: center;
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    line-height: 15px;
    height: 15px;
  }
}

.upload-size {
  color: #555;
  font-size: 0.9em;
  text-align: right;
  margin-top: 3px;
}

.btn-cancel {
  color: $primary-color;
  border: 1px solid $primary-color;
  border-radius: 5px;
  background: #fff;
  font-size: 1em;
  font-weight: 500;
  padding: 4px 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}

.upload-error {
  color: $error-color;
  font-size: 0.9em;
  text-align: center;
  padding: 5px 0;
}

.upload-finished {
  display: flex;
  align-items: center;
  color: green;
  font-size: 0.9em;
  i {
    font-size: 25px;
    margin-left: 5px;
    margin-right: 15px;
  }
}
</style>
